<div class="mainGalleryBlock">
  @if (loadingBar) {
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  }

  <div class='button'><button mat-raised-button color="primary" (click)="uploadImage()">Subir imágenes</button></div>

  <div class='imagesBlock'>
    @if (images.length == 0) {
      <span class='sinImagenes'>Sin imágenes...</span>
    }
    @for (image of images; track image) {
      <mat-card class='imageCard' style="background-image: url({{image.foto}});" matTooltip="Subida: {{image.fecha}}h" (click)="openImageBig(image.foto, image.fecha, image.id)"></mat-card>
    }
  </div>
</div>
